import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    actionsGrid: { display: 'flex', alignItems: 'center' },
    header: { marginTop: 16 },
    selectorTextGrid: { margin: 8 },
    selectorText: { fontSize: 14 },
    alert: {
      width: 'fit-content',
      margin: 32,
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    blockActionsDescription: { fontSize: 12 },
    alertText: { fontSize: 14 },
    loadingContainer: { marginTop: 64 },
    buttonsBlockServerActions: { margin: '8px 0px' },
  });
